import React from "react";
import ReactDOM from "react-dom";
import { connect } from 'react-redux';

class DateHolder extends React.Component {
    constructor(props) {
        super(props);
        
        var firstPeriodStart = props.firstPeriodStart ? props.firstPeriodStart.format('DD-MM-YYYY') : false,
            firstPeriodEnd = props.firstPeriodEnd ? props.firstPeriodEnd.clone().add(1, 'days').format('DD-MM-YYYY') : false,
            selectDateTrans = props.labels.select;
        
        this.state = {
            arrivalLabel: props.labels.arrival,
            departureLabel: props.labels.departure,
            startDateText: firstPeriodStart ? firstPeriodStart : selectDateTrans,
            endDateText: firstPeriodEnd ? firstPeriodEnd : selectDateTrans
        };
    }
    
    toggleCalendar = () => {
        var hideCalendar = !this.props.hideCalendar;
        let calendarBookingStatic = document.getElementById('calendar-booking-static');
        if(calendarBookingStatic){
            calendarBookingStatic.style.opacity = hideCalendar ? '1' : '0.3';
            calendarBookingStatic.style.pointerEvents = hideCalendar ? 'auto' : 'none';
        }
        
        this.props.onChange(hideCalendar);
    }
    
    render(){
        return(
            <div id="date-holder" className="date-holder row mb-3 white p-0 m-0 width-100">
                <div className="text-left col-sm-6 col-6 px-0 pr-1">
                    <label className="mb-2 inline-block font-w600">{this.state.arrivalLabel}</label>
                    <div onClick={this.toggleCalendar} className="btn btn-tertiary btn-sm width-100 date-holders start-date bor-blue3 flex items-center">
                        <img src="/assets/img/front/icons/calendar-blue3.svg" height="16" width="auto" className="mr-2" />
                        <div className="ucfirst font-w600">{this.state.startDateText}</div>
                    </div>
                </div>
                <div className="text-left col-sm-6 col-6 px-0 pl-1">
                    <label className="mb-2 inline-block font-w600 ">{this.state.departureLabel}</label>
                    <div onClick={this.toggleCalendar} className="btn btn-tertiary btn-sm width-100 date-holders end-date bor-blue3 flex items-center">
                        <img src="/assets/img/front/icons/calendar-blue3.svg" height="16" width="auto" className="mr-2"  />
                        <div className="ucfirst font-w600">{this.state.endDateText}</div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    firstPeriodStart: state.calendarStore.firstPeriodStart,
    firstPeriodEnd: state.calendarStore.firstPeriodEnd
});

export default connect(mapStateToProps)(DateHolder);